import { StorageHelper } from "./StorageHelper";

export class CookiesHelper {

    static loadGoogleScripts() {
        let body = <HTMLDivElement> document.body;
        if(!document.getElementById('gtagScript')) {
            let gtagScript = document.createElement('script');
            gtagScript.innerHTML = '';
            gtagScript.id = 'gtagScript';
            gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-974225369';
            gtagScript.async = true;
            gtagScript.defer = true;
            body.appendChild(gtagScript);
        }
    
        // TEMPORARILY DISABLED: Google Ads Script
        /*
        if(!document.getElementById('adsScript')) {
            let adsScript = document.createElement('script');
            adsScript.innerHTML = '';
            adsScript.id = 'adsScript';
            adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
            adsScript.async = true;
            adsScript.defer = true;
            adsScript['data-ad-client'] = 'ca-pub-8224058410680183';
            body.appendChild(adsScript);
        }
        */
      }
    
    static removeGoogleScripts() {
        if(document.getElementById('gtagScript')) {
            document.getElementById('gtagScript').remove();
        }
        if(document.getElementById('adsScript')) {
            document.getElementById('adsScript').remove();
        }
    }

    static accept(saveInStorage: boolean = true) {
        this.loadGoogleScripts();
        if(saveInStorage) {
            StorageHelper.getInstance().save(StorageHelper.keys.cookiesAccepted, "accepted");
        }
        (<any>window).gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
        });
        (<any>window).gtag('set', {'allow_google_signals': true});
        (<any>window).gtag('set', {'allow_ad_personalization_signals': true});
        window['ga-disable-AW-974225369'] = false;
        (<any>window).gtag('set', {'send_page_view': true });
        (<any>window).gtag('set', {'restricted_data_processing': true });
    }

    static decline(saveInStorage: boolean = true) {
        this.removeGoogleScripts();
        if(saveInStorage) {
            StorageHelper.getInstance().save(StorageHelper.keys.cookiesAccepted, "essentials");
        }
        (<any>window).gtag('consent', 'default', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
        });
        (<any>window).gtag('set', {'allow_google_signals': false});
        (<any>window).gtag('set', {'allow_ad_personalization_signals': false});
        window['ga-disable-AW-974225369'] = true;
        (<any>window).gtag('set', {'send_page_view': false });
        (<any>window).gtag('set', {'restricted_data_processing': false });
    }
}